import _capitalize from 'lodash/capitalize';
import { LOCALES } from 'localization/constants/configEnums';
import { SPECIAL_DISPLAY_BRAND_NAMES } from 'brand/enum/brands';
import { getLocale } from './getLocale';

/**
 * [startCase]
 *  very similar to lodash method startCase, minus the removal of ALL special characters. Just removes dashes and underscores.
 * @param  {string} value a string formatted like so 'new-balance' that needs to be in titlecase and have its dashes removed
 * @return {string} returns a string with the first letter of each word capitalized and only removes dashes and no other special characters
 * ...('chloé') -> 'Chloé'
 * ...('nike') -> Nike
 * ...('off-white') -> 'Off White'
 * ...('acne_studios') -> Acne Studios
 * ...('asics') -> 'ASICS' --> asics is a part of the special case brands that are included in the import SPECIAL_STRING_DISPLAY_MAP from strings utils
 */
const replaceDashAndUnderscores = (text: string) => {
  try {
    return text.replace(/-/g, ' ').replace(/_/g, ' ');
  } catch {
    return text;
  }
};

export const startCase = (
  value: string,
  options: {
    ignoreSpecialDisplay?: boolean;
    capitalizeInOtherLanguages?: boolean;
    removeDashAndUnderscores?: boolean;
  } = {},
) => {
  const {
    ignoreSpecialDisplay = false,
    capitalizeInOtherLanguages = true,
    removeDashAndUnderscores = true,
  } = options;

  if (SPECIAL_DISPLAY_BRAND_NAMES[value] && !ignoreSpecialDisplay) {
    return SPECIAL_DISPLAY_BRAND_NAMES[value];
  }

  let result = value;

  try {
    const locale = getLocale();
    const localesNotToStartCase = [LOCALES.frFR];

    if (removeDashAndUnderscores) {
      result = replaceDashAndUnderscores(result);
    }

    if (localesNotToStartCase.includes(locale)) {
      if (capitalizeInOtherLanguages) {
        return _capitalize(result);
      }
      return result.toLowerCase();
    }

    const formattedString = result
      .split(' ')
      // eslint-disable-next-line unicorn/no-array-reduce
      .reduce((acc, curr) => {
        return `${acc} ${curr.charAt(0).toUpperCase() + curr.slice(1)}`;
      }, '');

    if (formattedString.charAt(0) === ' ') {
      return formattedString.slice(1);
    }

    return formattedString;
  } catch {
    return result;
  }
};
